export enum Perfil {
  CAR_REGISTRO_CREDITO_DE_CARBONO = "CAR_REGISTRO_CREDITO_CARBONO",
  CAR_CONSULTA_CREDITO_DE_CARBONO = "CAR_CONSULTA_CREDITO_CARBONO",
  CAR_CONFIRMACAO_DE_REGISTRO_CREDITO_DE_CARBONO = "CAR_CONFIRMACAO_DE_REGISTRO_CREDITO_CARBONO",
  CAR_LANCAMENTO_DE_OPERACOES_CREDITO_DE_CARBONO = "CAR_LANCAMENTO_DE_OPERACOES_CREDITO_CARBONO",
  CAR_TRANSFERENCIA_CREDITO_DE_CARBONO = "CAR_TRANFERENCIA_CREDITO_CARBONO",
  CAR_RETIRADA_CREDITO_DE_CARBONO = "CAR_RETIRADA_CREDITO_CARBONO",
  CAR_CONSULTA_OPERACOES_CREDITO_DE_CARBONO = "CAR_CONSULTA_OPERACOES",
  CAR_CONFIRMA_OPERACOES_CREDITO_DE_CARBONO = "CAR_CONFIRMA_OPERACOES",
  CAR_CONSULTA_OPERACOES_POSICAO_CREDITO_DE_CARBONO = "CAR_CONSULTA_OPERACOES_POSICAO_CREDITO_DE_CARBONO",

  CAR_PSA_REGISTRA_PROJETO = "CAR_PSA_REGISTRA_PROJETO",
  CAR_PSA_CONSULTA_PROJETO = "CAR_PSA_CONSULTA_PROJETO",
  CAR_PSA_AUDITA_PROJETO = "CAR_PSA_AUDITA_PROJETO",
}
